import React from "react";
import { Typography, Stack, Box, Divider } from "digiwash-components";

import Icon from "../Icon";
import { formatPrice } from "digiwash-core";
import { TransactionsType } from "../../types/server";

interface PropTypes {
  data: TransactionsType;
}

function RowTransaction(props: PropTypes) {
  let transactionType = "";
  if (props.data.transaction_type === "increase") {
    transactionType += "افزایش";
  } else if (props.data.transaction_type === "decrease") {
    transactionType += "کاهش";
  }
  return (
    <Stack distribution="space-between" py="m">
      <Box>
        <Icon
          name={
            props.data.transaction_type === "increase"
              ? "arrow-up"
              : "arrow-down"
          }
          color={
            props.data.transaction_type === "increase"
              ? "green.main"
              : "red.main"
          }
          size={32}
        />
        <Divider size="xxl" />
      </Box>

      <Box
        style={{
          flexGrow: 1,
          flexShrink: 1,
        }}
        px="m"
      >
        {props.data && (
          <>
            <Typography fs="m" ff="mainBold" color="common.black">
              {transactionType} {formatPrice(props.data.amount)} تومان
            </Typography>
          </>
        )}
        <Divider size="l" />
        <Divider line />
      </Box>
    </Stack>
  );
}

export default RowTransaction;
